import React from "react";
import classNames from "classnames";

import styles from "./Spinner.css";

export default function Spinner(props) {
  return (
    <div className={!props.noContainer && styles.container}>
      <div className={styles.root}>
        { Array.from(Array(8)).map((x, i) => (
          <div
            key={i}
            className={classNames(styles[`node-${i}`], styles.node)}
            style={{
              left: `${15 * Math.cos(-0.25 * Math.PI * i)}px`,
              top: `${15 * Math.sin(-0.25 * Math.PI * i)}px`,
            }}
          />
        )) }
      </div>
    </div>
  );
}
